import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Grid, TableCell, TableRow } from "@mui/material";
import { Autocomplete, TextField } from "@totalsoft/rocket-ui";
import BlockIcon from "@mui/icons-material/Block";

const ScoringCategoryRowComponent = ({ options, category, validationInfo, disabled, onPropertyChange }) => {
  const { t } = useTranslation();

  const hiddenSensitiveData = () => {
    if (category.sensitiveInfo) {
      return true;
    }

    return false;
  };
  const handleOptionChange = (prop, options) => value => {
    var option = options.filter(a => a.scoringCategoryOptionId === value.id)[0];
    onPropertyChange("option", option);
  };

  const handleCategoryValueChange = value => {
    onPropertyChange("value", value);
  };

  return (
    <TableRow>
      <TableCell>{category.name}</TableCell>
      {hiddenSensitiveData() || category.valueInputTypeCode !== "NUMERIC" ? (
        <TableCell align="right">{""}</TableCell>
      ) : (
        <TableCell align="right">
          <TextField
            fullWidth
            isNumeric
            value={category.value}
            inputProps={{ decimalScale: category.scale ? category.scale : 2 }}
            onChange={handleCategoryValueChange}
            disabled={category.isReadOnly || disabled}
            error={validationInfo && validationInfo.value ? true : false}
          />
        </TableCell>
      )}
      {hiddenSensitiveData() ? (
        <TableCell align="left" style={{ padding: "0px 0px 4px 0px" }}>
          <Grid container spacing={1} justify="flex-start">
            <Grid item align="left"></Grid>
            <BlockIcon />
            <Grid item style={{ paddingLeft: "20px" }}>
              {t("Scoring.SensitiveInfo")}
            </Grid>
          </Grid>
        </TableCell>
      ) : (
        <TableCell sx={{ width: "35%", paddingBottom: ".25rem" }}>
          <Autocomplete
            id="category_option"
            fullWidth
            labelKey="name"
            valueKey="scoringCategoryOptionId"
            value={!category.option ? "" : category.option.scoringCategoryOptionId || ""}
            clearable={false}
            options={options}
            onChange={handleOptionChange("scoringCategoryOptionId", options)}
            disabled={category.isReadOnly || disabled}
            error={validationInfo && validationInfo.option ? true : false}
          />
        </TableCell>
      )}
      <TableCell align="right" colSpan={1}>
        {hiddenSensitiveData() || (!category.score && category.score !== 0)
          ? ""
          : t("NUMBER", { number: category.score })}
      </TableCell>
    </TableRow>
  );
};

ScoringCategoryRowComponent.propTypes = {
  category: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  validationInfo: PropTypes.object.isRequired,
  disabled: PropTypes.bool
};

export default ScoringCategoryRowComponent;
